import '.bp{flex-shrink:0;}.ssr-plugin'
import '.br{padding:1rem;}.ssr-plugin'
import '.a8{width:100%;}.ssr-plugin'
import '.bk{height:100%;}.ssr-plugin'
import '.b9{border:none;}.ssr-plugin'
import '.ba{background-color:transparent;}.ssr-plugin'
import '.ew{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.al{align-items:stretch;}.ssr-plugin'
import '.d3{position:sticky;}.ssr-plugin'
import '.ex{top:4rem;}.ssr-plugin'
import '.ey{z-index:7;}.ssr-plugin'
import '.as{background-color:var(--shades-white);}.ssr-plugin'
import '.ez{padding-bottom:1rem;}.ssr-plugin'
import '.t{margin-bottom:1rem;}.ssr-plugin'
import '.f0{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a5{position:fixed;}.ssr-plugin'
import '.c3{top:0;}.ssr-plugin'
import '.bi{left:0px;}.ssr-plugin'
import '.bj{right:0px;}.ssr-plugin'
import '.f1{bottom:0px;}.ssr-plugin'
import '.e5{z-index:9999;}.ssr-plugin'
import '.f2{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.ck{justify-content:flex-end;}.ssr-plugin'
import '.bt{flex:1;}.ssr-plugin'
import '.at{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bp br a8 bk b9 ba ew"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b al"
    >
      <div className="d3 ex ey as ez t f0 a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a5 c3 bi bj f1 e5 as f2 a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="br a ck f0"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bt at">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
